module.exports = __webpack_public_path__ + "static/media/gabillaud.d2d80793.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/gabillaud.jpg
 ** module id = 289
 ** module chunks = 0
 **/